import React, { Component } from "react";
import "../Styles/HomeStyle.css";
import amenitiesImage from "../Images/Amenities.jpg";
import forthekids from "../Images/ForTheKids.jpg";

export class Home extends Component {
  displayName = Home.name;

  render() {
    const about =
      "Locally owned and operated by the Calloway family since 1993, Calloway's Health and Fitness is a full service gym providing a superior workout experience for all your fitness needs. Whether you are looking to gain muscle, lose wieght or just relax by the pool, Calloway's is the gym for you! We offer over 50 group exercise classes per week to help keep you motivated. And with five weight rooms to challenge your muscles, you'll never get bored! There is something for everyone at Calloway's!";
    const amenities =
      "Calloway's has 5 weight rooms, a large cardio theater, a wide variety of group exercise classes, an indoor track, heated indoor pool, men's steam room, hot tubs, indeer basketball court, and an outdoor pool.";
    const kids =
      "Kids love our fun-filled childcare area complete with a huge play land. We also offer an outdoor kiddie pool and swimming lessons.";
    return (
      <div>
        <div name="Backdrop" className="home-banner-div allow-scroll"></div>
        <div className="container home-text">
          <div className="row" style={{ margin: "auto" }}>
            <h1 style={{ textAlign: "center" }}>Calloway's Health & Fitness</h1>
            <p>{about}</p>
          </div>
          <hr />
          <div className="row">
            <div className="col-md-8">
              <h2 style={{ textAlign: "center" }}>Amenities</h2>
              <p>{amenities}</p>
            </div>
            <div className="col-md-4" style={{ textAlign: "center" }}>
              <img
                src={amenitiesImage}
                alt="Pool"
                style={{ maxHeight: "215px" }}
              />
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-md-8">
              <h2 style={{ textAlign: "center" }}>For The Kids</h2>
              <p>{kids}</p>
            </div>
            <div className="col-md-4" style={{ textAlign: "center" }}>
              <img
                src={forthekids}
                alt="Kids Area"
                style={{ height: "250px" }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Home.js